import { Model } from '@vuex-orm/core';
import Residence from '@/models/Residence';

export default class Bedroom extends Model {
  static entity = 'bedrooms';

  static fields() {
    return {
      id: this.uid(),
      name: this.attr(null),
      slug: this.attr(null),
      count: this.attr(null),
      description: this.attr(null),

      residences: this.hasMany(Residence, 'bedroom_id'),
    }
  }

  static transformer(data) {
    const bedrooms = [];
    data.data.forEach(item => {
      const bedroom = {};
      bedroom.id = item.id;
      bedroom.name = item.name;
      bedroom.slug = item.slug;
      bedroom.count = item.count;
      bedroom.description = item.description;
      bedrooms.push(bedroom);
    })
    return bedrooms;
  }

  static apiConfig = {
    dataTransformer: (data) => this.transformer(data),
  }

  static fetch(baseURL) {
    let url = '/wp-json/wp/v2/rooms';
    return this.api().get(url, {
      baseURL: baseURL,
    });
  }
}